import { PopoverSortby } from '@/components/main/contests/popover-components/PopoverSortby'
import { SortBy, SortOrder } from '@/types/contest'
import { Control, UseFormSetValue } from 'react-hook-form'
import { PreferenceFormSchema } from '../../preference/form'

interface SortbySectionProps {
  setValue: UseFormSetValue<PreferenceFormSchema>
  control: Control<PreferenceFormSchema>
}

export function SortbySection({ setValue }: SortbySectionProps) {
  return (
    <section className="relative mt-[40px] flex items-center gap-[20px] px-3">
      <span className="font-bold">อื่นๆ</span>
      <PopoverSortby
        truncate={false}
        setSortBy={(value: SortBy) => {
          setValue('sortBy', value)
        }}
        setSortOrder={(order: SortOrder) => {
          setValue('sortOrder', order)
        }}
      />
    </section>
  )
}
